<template>
  <div>
    <el-form ref="formRef" :model="prizeForm" label-width="100px">
      <el-form-item label="名次：">
        <el-input v-model="prizeForm.rank" placeholder="请输入文案" style="width: 90%" ></el-input>
      </el-form-item>
      <el-form-item label="奖品：">
        <el-input v-model="prizeForm.prize" placeholder="请输入文案" style="width: 90%" ></el-input>
      </el-form-item>
      <el-form-item label="金额：">
        <el-input v-model="prizeForm.money" placeholder="请输入具体金额" style="width: 90%" ></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">确定</el-button>
    </div>
  </div>
</template>

<script>
import {postFormData} from "@/api/api";
import {updatePrize} from "@/api/url";

export default {
  name: "UpdateApplyStateDialog",
  props: {
    value: Object
  },
  data() {
    return {
      prizeForm: this.value.prizeForm,
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    submit() {
      this.loading = true
      let param = {}
      param['id'] = this.prizeForm.id
      param['rank'] = this.prizeForm.rank
      param['prize'] = this.prizeForm.prize
      param['money'] = this.prizeForm.money
      postFormData(updatePrize, param).then((data) => {
        let {code, msg} = data;
        if ( code == 200 ) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          this.$emit('confirm', param)
        } else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }

  }
}
</script>

<style scoped>

</style>
